<div class="skeleton">
  <div class="skeleton__buttons">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="skeleton__filters">
    <div class="skeleton__filters--dropdown"></div>
    <div class="skeleton__filters--button"></div>
    <div class="skeleton__filters--button"></div>
  </div>
  <div class="skeleton__current-folder"></div>
  <div class="skeleton__table">
    <div class="skeleton__table--header">
      @for (i of numberOfCells; track index; let index = $index) {
        <div></div>
      }
    </div>
    @for (i of numberOfRows; track index; let index = $index) {
      <div class="skeleton__table--row">
        @for (j of numberOfCells; track index; let index = $index) {
          <div></div>
        }
      </div>
    }
  </div>
</div>
